import React__default, { forwardRef } from 'react';
import { useButton } from 'react-aria';
import { StyledButton } from './styles.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';
import Box from '../Box/Box.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ButtonBase = /*#__PURE__*/forwardRef(({
  children,
  as: Component = 'button',
  leadingIcon: LeadingIcon,
  trailingIcon: TrailingIcon,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const {
    href,
    onPress
  } = props;
  if (href && onPress) {
    console.error(`Warning: Use an href with buttons that should render as semantic HTML <a> tags and an onPress handler with buttons that should render as semantic <button> tags, but not both.`);
  }
  const ariaButtonRef = props.buttonRef;
  const innerRef = React__default.useRef(null);
  const {
    buttonProps
  } = useButton(props, innerRef);
  if (ariaButtonRef) {
    useRefObjectAsForwardedRef(ariaButtonRef, innerRef);
  } else {
    useRefObjectAsForwardedRef(forwardedRef, innerRef);
  }

  // we need to remove margin in cases where consumers are only
  // passing a single icon to buttons
  const {
    isOnlySingleIcon,
    ariaLabel
  } = props;
  const iconWrapStyles = {
    display: 'inline-block',
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 0,
    lineHeight: 0
  };
  const trailingIconStyles = {
    ...iconWrapStyles,
    ml: isOnlySingleIcon ? '' : 1
  };
  return /*#__PURE__*/React__default.createElement(StyledButton, _extends({
    as: Component,
    "aria-label": ariaLabel,
    ref: innerRef,
    className: UNSAFE_className,
    href: Component === 'button' ? undefined : href,
    onPress: Component === 'a' ? undefined : onPress
  }, buttonProps, props), LeadingIcon && /*#__PURE__*/React__default.createElement(Box, {
    as: "span",
    "data-component": "leadingIcon",
    sx: iconWrapStyles
  }, /*#__PURE__*/React__default.createElement(LeadingIcon, null)), children && /*#__PURE__*/React__default.createElement("span", {
    "data-component": "text"
  }, children), TrailingIcon && /*#__PURE__*/React__default.createElement(Box, {
    as: "span",
    "data-component": "trailingIcon",
    sx: trailingIconStyles
  }, /*#__PURE__*/React__default.createElement(TrailingIcon, null)));
});
ButtonBase.displayName = 'ButtonBase';

export { ButtonBase };
